import { styled } from "@mui/material/styles";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import MenuContent from "./MenuContent";
import { useAuth } from "../../contexts/Auth";
import { useNavigate, Link } from "react-router-dom";

const drawerWidth = 170;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: "border-box",
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: "border-box",
  },
});

export default function SideMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", md: "block" },
        [`& .${drawerClasses.paper}`]: {
          background: "transparent",
        },
      }}
    >
      <Divider />
      <Box
        sx={{
          overflow: "auto",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <img
              src="/es-banner.svg"
              alt="Event Spy"
              style={{ height: "32px" }}
            />
          </Link>
        </Box>
        <MenuContent />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: "center",
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box sx={{ mr: "auto", maxWidth: "140px" }}>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              display: "block",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {user ? user.email.trim().toLowerCase() : ""}
          </Typography>
        </Box>
      </Stack>
      <Divider />
      <Stack sx={{ p: 1 }} direction="row" alignItems="center">
        <Button
          onClick={() => navigate("/settings")}
          variant="outlined"
          fullWidth
        >
          Settings
        </Button>
      </Stack>
      <Stack sx={{ p: 1 }} direction="row" alignItems="center">
        <Button
          onClick={handleLogout}
          variant="outlined"
          fullWidth
          startIcon={<LogoutRoundedIcon />}
        >
          Logout
        </Button>
      </Stack>
    </Drawer>
  );
}
